<ul class="checkbox-tree" [attr.data-testid]="automationKey">
  @for (
    checkboxNode of checkboxNodeMap | keyvalue; track trackByNode($index,
    checkboxNode)) {
    <li
      class="checkbox-tree__item"
      attr.data-testid="{{checkboxNode.value.id}}-section"
      >
      <div class="checkbox-tree__item-content">
        <jmkw-checkbox
          [id]="checkboxNode.key"
          [selected]="checkboxNode.value.selected"
          [indeterminate]="checkboxNode.value.indeterminate"
          [label]="checkboxNode.value.label"
          (selectChanged)="checkboxChangeHandler($event, checkboxNode)"
          [automationKey]="checkboxNode.value.automationKey"
          >
          @if (expandable && checkboxNode.value.children.size) {
            <span
              inside
              class="checkbox-tree__toggle"
              >
              <i
                class="icon-keyboard_arrow_right checkbox-tree__toggle-icon"
            [class.checkbox-tree__toggle-icon--expanded]="
              checkboxNode.value.expanded
            "
                (click)="toggleExpandHandler($event, checkboxNode.key)"
                >
              </i>
            </span>
          }
        </jmkw-checkbox>
      </div>
      @if (checkboxNode.value.children.size) {
        <div
          class="checkbox-tree__children"
      [class.checkbox-tree__children--expanded]="
        !expandable || checkboxNode.value.expanded
      "
          >
          <ul class="checkbox-tree__list">
            <jmkw-checkboxes
              [expandable]="expandable"
              [checkboxNodeMap]="checkboxNode.value.children"
              (nodeChanged)="onChildChange($event, checkboxNode.key)"
            ></jmkw-checkboxes>
          </ul>
        </div>
      }
    </li>
  }
</ul>
